declare var moment: any;

export class DateUtils {
    public static addDays(dateStr: string, days: number): Date {
        let date = new Date(dateStr);
        date.setDate(date.getDate() + days);
        return date;
    }

    public static areOnSameDay(mDate1: any, mDate2: any): boolean {
        return (
            mDate1.date() == mDate2.date() &&
            mDate1.month() == mDate2.month() &&
            mDate1.year() == mDate2.year()
        );
    }

    public static isPast(date: Date, timeZone: string): boolean {
        console.log('date and timezone are ', date, timeZone);
        let dateToUtc = DateUtils.toUtcDate(date, timeZone);
        console.log('adjusted to utc date is ', dateToUtc);
        let utcNow = DateUtils.utcNow();
        console.log('UTC time now is ', utcNow);
        console.log('date is past ', utcNow.isAfter(dateToUtc));
        return utcNow.isAfter(dateToUtc);
    }

    private static toUtcDate(date: Date, timeZone: string): any {
        return moment(
            moment(date)
                .utc()
                .add(moment.tz(timeZone))
                .format()
        );
    }

    private static utcNow(): any {
        return moment(
            moment()
                .utc()
                .format()
        );
    }

    public static timezone(): any {
        return -(moment().zone() / 60);
    }

    public static isoToDate(value: string, args?: string) {
        let date;
        value = value.toString();
        if (!Number.parseInt(value) || value.indexOf('T') >= 0) {
            date = moment(value)._d;
        } else {
            date = moment.unix(value)._d;
            if (date.getFullYear() > 3000) {
                date = moment.unix(Number.parseInt(value) / 1000)._d;
            }
        }

        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        let year = date.getFullYear();

        const resultDate = day + '-' + month + '-' + year;
        const mode = args;
        if (args == 'dateOnly')
            return resultDate;

        let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

        return resultDate + ', at ' + hours + ':' + minutes + ':' + seconds;
    }

    public static formatTime(date): any {
        return date ? moment(new Date(date)).format(' hh:mm A') : 'N/A';
    }
    public static formatDate(date): any {
        return date ? moment(new Date(date)).format('D MMM YYYY') : 'N/A';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/common/date-utils.ts